import React from 'react';
import { Form, DatePicker } from 'antd';
const FormItem = Form.Item;

const FieldDate = ({ data }) => {
	const { label, name, required } = data || {};

	return (
		<FormItem label={label} name={name} required={required}>
			<DatePicker />
		</FormItem>
	);
};

export default FieldDate;
